<!--
  Landingpage „Automatenkiosk“ (Hybrid: Konzept + kommerziell).
  Keywords: automatenkiosk / 24/7 kiosk / kiosk eröffnen. Intent know-lastig →
  erst erklären (Was ist / In 3 Schritten), dann Funnel (Vorteile, Live, Preise).
  Referenz: Automatenkiosk Langenargen. Cross-Link zu /automatenladen.
-->
<section class="lp-hero">
  <div class="content content--wide lp-hero__grid">
    <div class="lp-hero__text reveal">
      <div class="lp-hero__orb" aria-hidden="true">🏪</div>
      <span class="lp-eyebrow" i18n="@@kiosk.hero.eyebrow">24/7-Kiosk · ohne Personal</span>
      <h1 class="title display" i18n="@@kiosk.hero.h1">Automatenkiosk eröffnen</h1>
      <div class="line"></div>
      <p class="lp-lead" i18n="@@kiosk.hero.lead">
        Ein kleiner Laden, der rund um die Uhr verkauft – ganz ohne Personal. Ein Automatenkiosk aus
        einem oder mehreren <span class="tm">marktbox</span>-Modulen macht deinen Standort zum
        24/7-Verkaufspunkt: bargeldlos, wetterfest und flexibel für nahezu jedes Sortiment.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@kiosk.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="lp-cta__ghost" href="#konzept" (click)="scrollTo($event, 'konzept')" i18n="@@kiosk.hero.ctaAnchor">Was ist ein Automatenkiosk? ↓</a>
      </div>
    </div>
    <figure class="lp-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="Automatenkiosk mit marktbox – 24/7-Verkauf ohne Personal" i18n-alt="@@kiosk.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lp-hero__badge" i18n="@@kiosk.hero.badge">🔑 rund um die Uhr offen</span>
    </figure>
  </div>
</section>

<!-- ===== Was ist ein Automatenkiosk? (Konzept / know-Intent) ===== -->
<section id="konzept" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@kiosk.what.h2">Was ist ein Automatenkiosk?</h2>
    <p class="lp-intro reveal" i18n="@@kiosk.what.intro">
      Ein Automatenkiosk – oft auch „24/7-Kiosk“ genannt – ist ein unbemannter Verkaufsraum: Statt
      Öffnungszeiten, Kasse und Personal übernehmen Automaten den Verkauf. Die Kundschaft nimmt ihre
      Ware direkt aus dem Fach und zahlt bargeldlos. So bleibt dein Standort geöffnet, wenn andere
      längst geschlossen haben – abends, sonntags und feiertags. Mehrere Automaten zusammen ergeben
      ein komplettes Sortiment; die <span class="tm">marktbox</span> ist dabei am flexibelsten für
      unterschiedliche Waren.
    </p>
  </div>
</section>

<!-- ===== In 3 Schritten zum eigenen Automatenkiosk (know/do → „kiosk eröffnen“) ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@kiosk.steps.h2">In 3 Schritten zum eigenen Automatenkiosk</h2>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">1️⃣</span>
        <h3 i18n="@@kiosk.steps.s1.h3">Standort wählen</h3>
        <p i18n="@@kiosk.steps.s1.p">Gut sichtbar mit Laufkundschaft: am Hof, vor dem Laden, an Wohngebieten oder Ausflugszielen. Wichtig sind Sichtbarkeit und einfache Erreichbarkeit.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">2️⃣</span>
        <h3 i18n="@@kiosk.steps.s2.h3">Automaten aussuchen</h3>
        <p i18n="@@kiosk.steps.s2.p">Starte mit einer marktbox und erweitere Stück für Stück – auch mit Automaten anderer Hersteller. So wächst dein Kiosk mit dem Sortiment.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">3️⃣</span>
        <h3 i18n="@@kiosk.steps.s3.h3">Bestücken &amp; loslegen</h3>
        <p i18n="@@kiosk.steps.s3.p">Ware einräumen, Preise setzen – fertig. Der Verkauf läuft 24/7 automatisch, Füllstände und Zahlungen steuerst du bequem per App.</p>
      </div>
    </div>
    <p class="lp-fineprint reveal" i18n="@@kiosk.steps.fine">
      Du willst mehrere Automaten zu einem ganzen Laden kombinieren?
      <a [routerLink]="['/', 'automatenladen']">Mehr dazu auf der Seite Automatenladen eröffnen</a>.
    </p>
  </div>
</section>

<!-- ===== Warum die marktbox im Automatenkiosk (kommerziell) ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@kiosk.adv.h2">Warum die marktbox im Automatenkiosk?</h2>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">📦</span>
        <h3 i18n="@@kiosk.adv.c1.h3">Flexibel bis zum Bündel</h3>
        <p i18n="@@kiosk.adv.c1.p">Von Einzelartikeln bis zu Gebinden wie einem 6er-Bier – die marktbox deckt ab, was klassische Snack- oder Getränkeautomaten nicht können.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🧩</span>
        <h3 i18n="@@kiosk.adv.c2.h3">Kombinier- &amp; erweiterbar</h3>
        <p i18n="@@kiosk.adv.c2.p">Klein starten, Automat für Automat wachsen – auch im Verbund mit anderen Herstellern zu einem kompletten Kiosk.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">💳</span>
        <h3 i18n="@@kiosk.adv.c3.h3">Bargeldlos &amp; nachweisbar</h3>
        <p i18n="@@kiosk.adv.c3.p">Kartenzahlung am Automaten, jede Transaktion digital dokumentiert – kein Bargeld-Handling, kein zweites Kassenbuch.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🔒</span>
        <h3 i18n="@@kiosk.adv.c4.h3">Sicher &amp; wetterfest</h3>
        <p i18n="@@kiosk.adv.c4.p">Einzeln abschließbare Klappen und robuste Bauweise – drinnen wie draußen, rund um die Uhr geschützt.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Live-Link: Automatenkiosk Langenargen ===== -->
<section class="lp-section">
  <div class="content content--wide lp-live__grid">
    <div class="lp-live__text reveal">
      <span class="lp-eyebrow" i18n="@@kiosk.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lp-h2" i18n="@@kiosk.live.h2">Ein echter Automatenkiosk</h2>
      <p class="lp-lead" i18n="@@kiosk.live.lead">
        So sieht's live aus: der Automatenkiosk Langenargen mit der marktbox neben weiteren Automaten.
        Die Kundschaft sieht in Echtzeit, was gerade verfügbar ist – noch bevor sie losfährt.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@kiosk.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@kiosk.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@kiosk.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@kiosk.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Automatenkiosk Langenargen: Echtzeit-Verfügbarkeit" i18n-title="@@kiosk.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@kiosk.live.cap">Live-Beispiel: Automatenkiosk Langenargen</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@kiosk.price.h2">Automatenkiosk starten – kaufen oder mieten</h2>
    <div class="lp-price-grid">
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@kiosk.price.buyLabel">Kaufen</span>
        <span class="lp-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@kiosk.price.buyText">Einmalige Investition – ideal, wenn der Kiosk dauerhaft an einem Standort läuft.</p>
      </div>
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@kiosk.price.rentLabel">Mieten</span>
        <span class="lp-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@kiosk.price.rentText">Klein starten, später erweitern – planbare Kosten für den Aufbau deines Kiosks.</p>
      </div>
    </div>
    <div class="lp-cta lp-cta--center reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@kiosk.price.cta">Zum Shop</a>
    </div>
    <p class="lp-fineprint reveal" i18n="@@kiosk.price.fine">
      Mehr zum Trend: <a [routerLink]="['/', links.blog, blogSlug]">Mit einem Automaten-Kiosk voll im Trend</a>
    </p>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@kiosk.faq.h2">Häufige Fragen zum Automatenkiosk</h2>
    <div class="lp-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lp-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lp-section lp-final reveal">
  <div class="content content--wide">
    <h2 class="lp-h2" i18n="@@kiosk.final.h2">Bereit für deinen Automatenkiosk?</h2>
    <p class="lp-lead" i18n="@@kiosk.final.lead">Starte mit der flexibelsten Box und wachse Automat für Automat zum eigenen 24/7-Kiosk.</p>
    <div class="lp-cta lp-cta--center">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@kiosk.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
